<template>
  <v-container fluid class="tf-hero">
    <v-container>
      <v-row align="center" class="py-md-16">

        <!-- Left column -->
        <v-col cols="12" md="6" data-aos="fade-right">
          <v-chip
            small
            class="mb-4 font-weight-bold"
            :style="{
              backgroundColor: '#00695C1A',
              color: '#00695C',
            }"
          >
            Comercio Exterior Digital
          </v-chip>

          <h1
            class="display-1 font-weight-bold white--text mb-6"
            style="line-height: 1.2;"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Deja de gestionar BLs, packing lists y
            facturas por WhatsApp y Excel
          </h1>

          <v-list
            dense
            class="transparent mb-8"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <v-list-item
              v-for="(bullet, i) in bullets"
              :key="i"
              class="px-0"
            >
              <v-list-item-icon class="mr-2">
                <v-icon color="#00695C">
                  {{ bullet.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">
                  {{ bullet.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <div data-aos="fade-up" data-aos-delay="300">
            <v-btn
              :x-large="$vuetify.breakpoint.mdAndUp"
              :large="$vuetify.breakpoint.smAndDown"
              depressed
              class="mr-4 mb-4 white--text"
              :style="{ backgroundColor: '#00695C' }"
              href="#tf-contact"
              rounded
            >
              Solicitar Demo
            </v-btn>
            <v-btn
              :x-large="$vuetify.breakpoint.mdAndUp"
              :large="$vuetify.breakpoint.smAndDown"
              outlined
              dark
              class="mb-4"
              href="#tf-solution"
              rounded
            >
              Ver Cómo Funciona
            </v-btn>
          </div>
        </v-col>

        <!-- Right column — dashboard mockup -->
        <v-col
          cols="12"
          md="6"
          class="d-flex justify-center"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <div class="tf-dashboard-mockup">
            <!-- Browser frame -->
            <div class="tf-browser-frame">
              <div class="tf-browser-dots">
                <span></span><span></span><span></span>
              </div>
              <div class="tf-browser-url">app.tradeflow.com/home/resumen</div>
            </div>
            <!-- App layout -->
            <div class="tf-app-layout">
              <!-- Sidebar -->
              <div class="tf-sidebar">
                <div class="tf-sb-logo">TF</div>
                <div class="tf-sb-item tf-sb-item--active">&#9776;</div>
                <div class="tf-sb-item">&#128196;</div>
                <div class="tf-sb-item">&#9201;</div>
                <div class="tf-sb-item">&#9888;</div>
                <div class="tf-sb-item">&#9881;</div>
                <div class="tf-sb-avatar">JL</div>
              </div>
              <!-- Main -->
              <div class="tf-main">
                <!-- Top nav tabs -->
                <div class="tf-nav-tabs">
                  <span class="tf-nav-tab tf-nav-tab--active">Resumen General</span>
                  <span class="tf-nav-tab">Mis Métricas</span>
                  <span class="tf-nav-tab">Gestiones</span>
                  <span class="tf-nav-tab">Tiempos</span>
                  <span class="tf-nav-tab">Críticas</span>
                </div>
                <!-- Page header -->
                <div class="tf-page-header">
                  <div>
                    <div class="tf-page-title">Métricas y Totales</div>
                    <div class="tf-page-sub">Panel de control de gestión de embarques</div>
                  </div>
                  <div class="tf-header-actions">
                    <span class="tf-btn-icon">&#8635;</span>
                    <span class="tf-btn-icon">&#8681;</span>
                  </div>
                </div>
                <!-- KPI Cards -->
                <div class="tf-kpi-row">
                  <div class="tf-kpi">
                    <div class="tf-kpi-icon tf-kpi-icon--blue">&#128202;</div>
                    <div class="tf-kpi-info">
                      <div class="tf-kpi-label">Total Gestiones</div>
                      <div class="tf-kpi-sub">TOTAL GENERAL</div>
                    </div>
                    <div class="tf-kpi-val">2,847</div>
                    <div class="tf-kpi-chip tf-kpi-chip--green">Activo</div>
                  </div>
                  <div class="tf-kpi">
                    <div class="tf-kpi-icon tf-kpi-icon--green">&#10004;</div>
                    <div class="tf-kpi-info">
                      <div class="tf-kpi-label">Completadas</div>
                      <div class="tf-kpi-sub">FINALIZADAS</div>
                    </div>
                    <div class="tf-kpi-val">1,923<span class="tf-kpi-pct">(68%)</span></div>
                    <div class="tf-kpi-chip">Finalizadas</div>
                  </div>
                  <div class="tf-kpi">
                    <div class="tf-kpi-icon tf-kpi-icon--orange">&#9998;</div>
                    <div class="tf-kpi-info">
                      <div class="tf-kpi-label">En Progreso</div>
                      <div class="tf-kpi-sub">PENDIENTES</div>
                    </div>
                    <div class="tf-kpi-val">924<span class="tf-kpi-pct">(32%)</span></div>
                    <div class="tf-kpi-chip tf-kpi-chip--orange">Activas</div>
                  </div>
                  <div class="tf-kpi">
                    <div class="tf-kpi-icon tf-kpi-icon--purple">&#128337;</div>
                    <div class="tf-kpi-info">
                      <div class="tf-kpi-label">Tiempo Promedio</div>
                      <div class="tf-kpi-sub">POR ESTADO</div>
                    </div>
                    <div class="tf-kpi-val">8.3<span class="tf-kpi-unit">días</span></div>
                    <div class="tf-kpi-chip">Promedio</div>
                  </div>
                </div>
                <!-- Charts row -->
                <div class="tf-charts-row">
                  <div class="tf-chart-card">
                    <div class="tf-chart-title">Distribución por Tipo</div>
                    <!-- Donut chart CSS -->
                    <div class="tf-donut-wrap">
                      <div class="tf-donut">
                        <div class="tf-donut-hole"></div>
                      </div>
                      <div class="tf-donut-legend">
                        <span><i class="tf-dot tf-dot--g1"></i>Exportaciones</span>
                        <span><i class="tf-dot tf-dot--g2"></i>Importaciones</span>
                        <span><i class="tf-dot tf-dot--g3"></i>Control gastos</span>
                      </div>
                    </div>
                  </div>
                  <div class="tf-chart-card">
                    <div class="tf-chart-title">Distribución por Estado</div>
                    <div class="tf-bar-chart">
                      <div class="tf-bar-group">
                        <div class="tf-bar" style="height:85%">
                          <div class="tf-bar-fill tf-bar--c1"></div>
                        </div>
                        <div class="tf-bar" style="height:60%">
                          <div class="tf-bar-fill tf-bar--c2"></div>
                        </div>
                        <div class="tf-bar" style="height:45%">
                          <div class="tf-bar-fill tf-bar--c3"></div>
                        </div>
                        <div class="tf-bar" style="height:72%">
                          <div class="tf-bar-fill tf-bar--c4"></div>
                        </div>
                        <div class="tf-bar" style="height:30%">
                          <div class="tf-bar-fill tf-bar--c5"></div>
                        </div>
                        <div class="tf-bar" style="height:55%">
                          <div class="tf-bar-fill tf-bar--c6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>

      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'TFHero',
  data() {
    return {
      bullets: [
        {
          icon: 'mdi-check-circle',
          text: 'Centralización de documentos de embarque',
        },
        {
          icon: 'mdi-check-circle',
          text: 'Rastreo de pedimentos en tiempo real',
        },
        {
          icon: 'mdi-check-circle',
          text: 'Control de gastos de flete por operación',
        },
        {
          icon: 'mdi-check-circle',
          text: 'Validación de documentos con AI',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tf-hero {
  background: linear-gradient(135deg, #00695C 0%, #004D40 100%);
  position: relative;
  overflow: hidden;
  padding-bottom: 64px;
}

.tf-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(
    circle,
    rgba(0, 150, 136, 0.15) 0%,
    transparent 70%
  );
  border-radius: 50%;
}

.transparent {
  background: transparent !important;
}

/* Dashboard mockup */
.tf-dashboard-mockup {
  max-width: 520px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.35);
}

.tf-browser-frame {
  background: #1e1e2e;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tf-browser-dots {
  display: flex;
  gap: 5px;
  span {
    width: 9px; height: 9px;
    border-radius: 50%; display: block;
  }
  span:nth-child(1) { background: #ff5f57; }
  span:nth-child(2) { background: #ffbd2e; }
  span:nth-child(3) { background: #28c840; }
}

.tf-browser-url {
  background: rgba(255,255,255,0.08);
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 10px;
  color: rgba(255,255,255,0.45);
  flex: 1;
  font-family: monospace;
}

/* App layout */
.tf-app-layout {
  display: flex;
  height: 380px;
  background: #f0f2f8;
}

/* Sidebar */
.tf-sidebar {
  width: 40px;
  background: #0F2A4D;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
  gap: 6px;
  flex-shrink: 0;
}

.tf-sb-logo {
  width: 28px; height: 28px;
  background: #00695C;
  border-radius: 6px;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.tf-sb-item {
  width: 28px; height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: rgba(255,255,255,0.4);
  cursor: default;
}

.tf-sb-item--active {
  background: rgba(255,255,255,0.12);
  color: #fff;
}

.tf-sb-avatar {
  width: 26px; height: 26px;
  background: #FF6B35;
  border-radius: 50%;
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
}

/* Main content */
.tf-main {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Nav tabs */
.tf-nav-tabs {
  display: flex;
  gap: 0;
  background: #fff;
  border-bottom: 2px solid #eee;
  padding: 0 10px;
  flex-shrink: 0;
}

.tf-nav-tab {
  font-size: 8px;
  padding: 7px 8px;
  color: #8D99AE;
  font-weight: 600;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  white-space: nowrap;
}

.tf-nav-tab--active {
  color: #0F2A4D;
  border-bottom-color: #3B82F6;
}

/* Page header */
.tf-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 6px;
}

.tf-page-title {
  font-size: 12px;
  font-weight: 800;
  color: #0F2A4D;
}

.tf-page-sub {
  font-size: 8px;
  color: #8D99AE;
}

.tf-header-actions {
  display: flex;
  gap: 4px;
}

.tf-btn-icon {
  width: 22px; height: 22px;
  border-radius: 6px;
  background: #f0f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #8D99AE;
}

/* KPI row */
.tf-kpi-row {
  display: flex;
  gap: 6px;
  padding: 0 12px 8px;
}

.tf-kpi {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 8px 7px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  text-align: center;
}

.tf-kpi-icon {
  width: 22px; height: 22px;
  border-radius: 50%;
  margin: 0 auto 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
}

.tf-kpi-icon--blue { background: #DBEAFE; color: #3B82F6; }
.tf-kpi-icon--green { background: #D1FAE5; color: #10B981; }
.tf-kpi-icon--orange { background: #FFF3E0; color: #F59E0B; }
.tf-kpi-icon--purple { background: #EDE9FE; color: #8B5CF6; }

.tf-kpi-info { margin-bottom: 2px; }

.tf-kpi-label {
  font-size: 7px;
  font-weight: 700;
  color: #0F2A4D;
}

.tf-kpi-sub {
  font-size: 6px;
  color: #8D99AE;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tf-kpi-val {
  font-size: 16px;
  font-weight: 800;
  color: #0F2A4D;
  line-height: 1.2;
}

.tf-kpi-pct {
  font-size: 8px;
  font-weight: 500;
  color: #8D99AE;
  margin-left: 1px;
}

.tf-kpi-unit {
  font-size: 9px;
  font-weight: 500;
  color: #8D99AE;
  margin-left: 2px;
}

.tf-kpi-chip {
  display: inline-block;
  font-size: 6px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #f0f2f8;
  color: #8D99AE;
  margin-top: 3px;
  font-weight: 600;
}

.tf-kpi-chip--green { background: #D1FAE5; color: #10B981; }
.tf-kpi-chip--orange { background: #FFF3E0; color: #F59E0B; }

/* Charts row */
.tf-charts-row {
  display: flex;
  gap: 6px;
  padding: 0 12px 12px;
  flex: 1;
  min-height: 0;
}

.tf-chart-card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  overflow: hidden;
}

.tf-chart-title {
  font-size: 8px;
  font-weight: 700;
  color: #0F2A4D;
  margin-bottom: 6px;
}

/* Donut chart */
.tf-donut-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tf-donut {
  width: 70px; height: 70px;
  border-radius: 50%;
  background: conic-gradient(
    #00695C 0% 52%,
    #10B981 52% 78%,
    #93C5FD 78% 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tf-donut-hole {
  width: 38px; height: 38px;
  border-radius: 50%;
  background: #fff;
}

.tf-donut-legend {
  display: flex;
  flex-direction: column;
  gap: 3px;

  span {
    font-size: 7px;
    color: #555;
    display: flex;
    align-items: center;
    gap: 3px;
  }
}

.tf-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.tf-dot--g1 { background: #00695C; }
.tf-dot--g2 { background: #10B981; }
.tf-dot--g3 { background: #93C5FD; }

/* Bar chart */
.tf-bar-chart {
  height: 80px;
  display: flex;
  align-items: flex-end;
  padding-top: 4px;
}

.tf-bar-group {
  display: flex;
  gap: 5px;
  align-items: flex-end;
  width: 100%;
  height: 100%;
}

.tf-bar {
  flex: 1;
  border-radius: 3px 3px 0 0;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
}

.tf-bar-fill {
  width: 100%;
  height: 100%;
  border-radius: 3px 3px 0 0;
}

.tf-bar--c1 { background: #3B82F6; }
.tf-bar--c2 { background: #10B981; }
.tf-bar--c3 { background: #F59E0B; }
.tf-bar--c4 { background: #8B5CF6; }
.tf-bar--c5 { background: #EF4444; }
.tf-bar--c6 { background: #06B6D4; }

@media (max-width: 600px) {
  .tf-dashboard-mockup { max-width: 100%; }
  .tf-app-layout { height: 300px; }
  .tf-kpi-val { font-size: 13px; }
  .tf-kpi-label { font-size: 6px; }
  .tf-nav-tab { font-size: 7px; padding: 5px 5px; }
  .tf-sidebar { width: 32px; }
  .tf-sb-logo { width: 22px; height: 22px; font-size: 7px; }
  .tf-sb-item { width: 22px; height: 22px; font-size: 9px; }
  .tf-sb-avatar { width: 20px; height: 20px; font-size: 7px; }
  .tf-donut { width: 50px; height: 50px; }
  .tf-donut-hole { width: 26px; height: 26px; }
}
</style>
